import {
  CurrentMarketActionTypes,
  MarketActionTypes,
  REQUEST_CURRENT_MARKET,
  REQUEST_MARKETS,
  REQUEST_LOGIN_METHODS,
  LoginMethodActionTypes
} from "./types";

import * as MarketApi from "../../api/marketApi";
import { isOk } from "../../result";
import { LoginMethod, Market } from "../../models/Market";

function fetchMarkets(markets: ReadonlyArray<Market>): MarketActionTypes {
  return {
    type: REQUEST_MARKETS,
    payload: markets
  };
}

export const thunkFetchMarkets = () => async (dispatch: any) => {
  try {
    const result = await MarketApi.list();
    if (isOk(result)) {
      dispatch(fetchMarkets(result.value));
    }
  } catch (error) {
    console.log(error);
  }
};

function fetchCurrentMarket(market: Market): CurrentMarketActionTypes {
  return {
    type: REQUEST_CURRENT_MARKET,
    payload: market
  };
}

export const thunkFetchCurrentMarket = () => async (dispatch: any) => {
  try {
    const result = await MarketApi.getCurrentMarket();
    if (isOk(result)) {
      dispatch(fetchCurrentMarket(result.value));
    }
  } catch (error) {
    console.log(error);
  }
};

function fetchLoginMethods(
  loginMethods: ReadonlyArray<LoginMethod>
): LoginMethodActionTypes {
  return {
    type: REQUEST_LOGIN_METHODS,
    payload: loginMethods
  };
}

export const thunkFetchLoginMethods = () => async (dispatch: any) => {
  try {
    const result = await MarketApi.getLoginMethods();
    if (isOk(result)) {
      dispatch(fetchLoginMethods(result.value));
    }
  } catch (error) {
    console.log(error);
  }
};
